import { graphql, useStaticQuery } from "gatsby";
import { useLocalizePath } from "internationalization";
import { truncate } from "lodash";

/**
 * @param {import("./Seo").SeoProps | null} [props]
 */
function useSeo(props) {
  const { data, fallback, page, canonical: canonicalUrl } = props ?? {};

  const localizePath = useLocalizePath();

  /** @type {string[]} */
  const robots = [
    data?.index === true ? "index" : data?.index === false ? "noindex" : "",
    data?.follow === true ? "follow" : data?.follow === false ? "nofollow" : "",
  ].filter(Boolean);

  const { site } = useStaticQuery(graphql`
    query SiteMetadataQuery {
      site {
        ...SiteMetadata
      }
    }
  `);

  /** @type {string} */
  const pathname = localizePath(page ?? "");

  /** @type {string} */
  const canonical =
    canonicalUrl || new URL(pathname, site.siteMetadata.siteURL).toString();

  /** @type {string[]} */
  const keywords =
    data?.keywords?.split(",").map((keyword) => keyword.trim()) ??
    fallback?.keywords?.split(",").map((keyword) => keyword.trim()) ??
    [];

  /** @type {string} */
  const title = data?.title || fallback?.title || "SEMANČÍN & PARTNERS";

  /** @type {string} */
  const description = truncate(
    data?.description || fallback?.description || "",
    {
      length: 160,
    },
  );

  return {
    title,
    description,
    keywords,
    robots,
    canonical,
  };
}

export default useSeo;
